import { Button, Dialog, EmptyState, Icon, Icons, Intent, List, ListItem, Size, Spinner } from "construct-ui";
import languageModel from "../../models/language.model";
import ProductModelModel from "../../models/product-model/product-model.model";
import QueryListComponent from "../query-list/query-list.component";
import ViewBase from "../../views/view-base.view";

export default function SelectModelForNewModelDisplayComponent() {

  ViewBase.call(this);

  let required = false;
  let isOpenItemSelect = false;
  let isSearching = false;
  let itemList = [];
  let selectedItemList = [];
  let uiListHeight = '300px'
  let selectedWeek = '';

  let onSelect = (e) => { };

  let clearSelection = () => {
    selectedItemList.splice(0);
    onSelect(selectedItemList);
  }

  let getModels = (week = '') => {
    if (!week) {
      itemList.splice(0);
      clearSelection();
      return;
    }

    if (selectedWeek === week) {
      return;
    }

    selectedWeek = week;
    isSearching = true;
    itemList.splice(0);
    ProductModelModel.getModelForNewModelDisplayFlooring(week)
      .then(result => {
        if (result) {
          result.map(r => {
            itemList.push({
              modelCode: r.modelCode,
              modelName: `${r.modelName} (${r.modelCode})`
            });
          })
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        isSearching = false;
      })
  }

  let deselectItem = (modelCode) => {
    let idx = selectedItemList.findIndex(s => s.modelCode === modelCode);
    if (idx > -1) {
      selectedItemList.splice(idx, 1);
      onSelect(selectedItemList);
    }
  }

  let renderLabel = (week) => {
    if (!week) {
      return this.getText("LT00000720", "Please select week");
    }

    if (selectedItemList && selectedItemList.length > 0) {
      return selectedItemList.length + ' ' + this.getText("LT00000308", "item(s) selected");
    }

    return this.getText("LT00000201", "Please select");
  }

  let SelectItemDialogContent = {
    oninit: (vnode) => {
      getModels(vnode.attrs.week);
    },
    view: (vnode) => {
      return m('.container',
        m('.row.g-4',
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: `min-height: ${uiListHeight}` },
                  (itemList.length > 0)
                    ? m(QueryListComponent, {
                      items: itemList,
                      itemKey: 'modelCode',
                      itemValue: 'modelName',
                      selectedItems: selectedItemList,
                      multiple: true,
                      onSelect: onSelect,
                      listAttrs: {
                        style: 'max-height: calc(100% - 55px);' // Max height - height of filter input with margin
                      },
                      style: {
                        height: uiListHeight
                      }
                    })
                    : m(EmptyState, {
                      icon: Icons.ARCHIVE,
                      content: this.getText("LT00000317", "No results found"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    })
                ),
                isSearching && m(Spinner, { fill: true, background: true, active: true })
              )
            ),
            m('.d-flex.justify-content-end',
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                ((itemList.length > 0 ? itemList.length : '0') + ' ' + this.getText("LT00000364", "record(s)"))
              )
            )
          ),
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: `min-height: ${uiListHeight}` },
                  selectedItemList && selectedItemList.length > 0
                    ? m(List, {
                      interactive: true,
                      style: {
                        height: uiListHeight
                      }
                    },
                      selectedItemList.map(item => m(ListItem, {
                        label: item.modelName,
                        contentRight: m(Icon, {
                          name: Icons.X,
                          intent: Intent.NEGATIVE,
                          onclick: e => {
                            deselectItem(item.modelCode);
                          }
                        })
                      }))
                    )
                    : m(EmptyState, {
                      icon: Icons.LIST,
                      content: languageModel.getText("LT00000719", "No items selected"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    }),
                )
              )
            ),
            m('.d-flex.justify-content-end.align-items-center.gap-3',
              m('a.btn.btn-link.p-0.mt-1', { onclick: clearSelection }, this.getText("LT00000545", "Clear selections")),
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                ((selectedItemList ? selectedItemList.length : '0') + ' ' + this.getText("LT00000364", "record(s)"))
              )
            )
          )
        )
      )
    }
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onSelect) {
        onSelect = vnode.attrs.onSelect;
      }

      if (vnode.attrs.selectedItemList) {
        selectedItemList = vnode.attrs.selectedItemList;
      }

      if (vnode.attrs.required) {
        required = vnode.attrs.required;
      }
    },
    onupdate: (vnode) => {
      if (vnode.attrs.selectedItemList) {
        selectedItemList = vnode.attrs.selectedItemList;
      }
    },
    view: (vnode) => {
      return [
        m(Button, {
          align: 'left',
          compact: true,
          class: 'select-list '
            + ((required && (!selectedItemList || selectedItemList.length == 0)) ? 'is-invalid-custom ' : '')
            + (!(selectedItemList?.length > 0) ? 'select-list-placeholder ' : '')
            + (vnode.attrs.class ? vnode.attrs.class : ''),
          disabled: vnode.attrs.disabled === true,
          fluid: true,
          iconRight: Icons.LIST,
          id: vnode.attrs.id,
          label: renderLabel(vnode.attrs.week),
          outlined: true,
          onclick: () => isOpenItemSelect = !isOpenItemSelect,
        }),
        isOpenItemSelect &&
        m(Dialog, {
          class: 'cui-dialog-xl',
          closeOnOutsideClick: false,
          isOpen: isOpenItemSelect,
          onClose: () => isOpenItemSelect = false,
          title: this.getText("LT00000718", "Model Selection"),
          content: m(SelectItemDialogContent, {
            onClose: () => { isOpenItemSelect = false },
            week: vnode.attrs.week,
          }),
          footer: [
            m('.d-flex.justify-content-end',
              m(Button, {
                label: this.getText("LT00000021", "Close"),
                intent: 'primary',
                onclick: () => { isOpenItemSelect = false },
              })
            )
          ]
        }),
        this.getBaseViews()
      ]
    }
  }
}
